// Stránky investičních bytů – předvýběr jednotky ve formuláři „Nezávazný dotaz“ (sekce Kontakt).
// Odkaz „Mám zájem o byt č. …“ na kartě (nabidka.php) a „Poptat →“ u garáže (garaze.php) mají
// href="#kontakt" a v data-re-pick hodnotu volby výběru `jednotka` (includes/redesign/reality-form.php).
// Na kotvu prohlížeč odskočí sám, tady se jen nastaví výběr. Volbu, kterou výběr nemá (prodaná
// jednotka, formulář bez výběru), nechá být.

export default function initRealityForm() {
  const select = document.querySelector('#kontakt select[name="jednotka"]');

  if (!select) {
    return;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-re-pick]');
    if (!link) {
      return;
    }

    const value = link.getAttribute('data-re-pick');
    if (!Array.from(select.options).some((option) => option.value === value)) {
      return;
    }

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
